import { render, staticRenderFns } from "./addOffer.vue?vue&type=template&id=24657278&scoped=true"
import script from "./addOffer.vue?vue&type=script&lang=js"
export * from "./addOffer.vue?vue&type=script&lang=js"
import style0 from "./addOffer.vue?vue&type=style&index=0&id=24657278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24657278",
  null
  
)

export default component.exports